import type { QueryResult } from 'react-apollo';

import { keys as sessionStorageKeys } from '@confluence/storage-manager';

import type {
	FeedPopularFeedQuery,
	FeedPopularFeedQueryVariables,
} from './__types__/FeedPopularFeedQuery';
import { PopularFeedTimeGranularityValue } from './Feed';
import { useFeedDropdownStorage } from './useFeedDropdownStorage';

export const useFeedTimeGranularityStorage = (
	feedContentQuery: QueryResult<FeedPopularFeedQuery, FeedPopularFeedQueryVariables>,
): {
	feedTimeGranularity: PopularFeedTimeGranularityValue;
	setFeedTimeGranularity: (sorting: PopularFeedTimeGranularityValue) => void;
} => {
	const { value: feedTimeGranularity, setValue: setFeedTimeGranularity } = useFeedDropdownStorage<
		FeedPopularFeedQuery,
		FeedPopularFeedQueryVariables,
		PopularFeedTimeGranularityValue
	>(feedContentQuery, {
		defaultValue: PopularFeedTimeGranularityValue.Default,
		sessionStorageKey: sessionStorageKeys.HOME_POPULAR_FEED_TIME_GRANULARITY,
	});

	return { feedTimeGranularity, setFeedTimeGranularity };
};
